module.exports = __webpack_public_path__ + "static/img/light-03.695d731.png";